module.exports = __webpack_public_path__ + "static/media/bi_novo.41b80472.webp";